var _mask, _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 217,
    viewBox: "0 0 177 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_200_390",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 9,
    width: 177,
    height: 208,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    y: 9,
    width: 177,
    height: 208
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 10C111.761 10 114 12.2386 114 15V19.2793C129.785 21.6652 145.314 26.2787 160.107 33.1211C169.797 37.6029 176 47.3056 176 57.9814V202C176 209.732 169.732 216 162 216H15C7.26801 216 1 209.732 1 202V57.9814C1.00013 47.3056 7.20304 37.6029 16.8926 33.1211C31.6858 26.2787 47.2147 21.6652 63 19.2793V15C63 12.2386 65.2386 10 68 10H109Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109 10C111.761 10 114 12.2386 114 15V19.2793C129.785 21.6652 145.314 26.2787 160.107 33.1211C169.797 37.6029 176 47.3056 176 57.9814V202C176 209.732 169.732 216 162 216H15C7.26801 216 1 209.732 1 202V57.9814C1.00013 47.3056 7.20304 37.6029 16.8926 33.1211C31.6858 26.2787 47.2147 21.6652 63 19.2793V15C63 12.2386 65.2386 10 68 10H109Z",
    fill: "#F2F8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114 15L115 15V15L114 15ZM114 19.2793H113V20.1395L113.851 20.2681L114 19.2793ZM160.107 33.1211L160.527 32.2135L160.527 32.2135L160.107 33.1211ZM176 57.9814L177 57.9814L177 57.9814L176 57.9814ZM176 202L177 202V202H176ZM1 202L0 202L0 202L1 202ZM1 57.9814L0 57.9814V57.9814H1ZM16.8926 33.1211L16.4728 32.2135L16.4728 32.2135L16.8926 33.1211ZM63 19.2793L63.1494 20.2681L64 20.1395V19.2793H63ZM68 10L68 9H68L68 10ZM109 10V11C111.209 11 113 12.7909 113 15L114 15L115 15C115 11.6863 112.314 9 109 9V10ZM114 15H113V19.2793H114H115V15H114ZM114 19.2793L113.851 20.2681C129.543 22.64 144.981 27.2264 159.688 34.0287L160.107 33.1211L160.527 32.2135C145.647 25.331 130.027 20.6904 114.149 18.2905L114 19.2793ZM160.107 33.1211L159.688 34.0287C169.023 38.3469 175 47.6954 175 57.9815L176 57.9814L177 57.9814C177 46.9158 170.57 36.8589 160.527 32.2135L160.107 33.1211ZM176 57.9814H175V202H176H177V57.9814H176ZM176 202L175 202C175 209.18 169.18 215 162 215V216V217C170.284 217 177 210.284 177 202L176 202ZM162 216V215H15V216V217H162V216ZM15 216V215C7.8203 215 2 209.18 2 202L1 202L0 202C3.41701e-07 210.284 6.71573 217 15 217V216ZM1 202H2V57.9814H1H0V202H1ZM1 57.9814L2 57.9815C2.00012 47.6954 7.97657 38.3469 17.3124 34.0287L16.8926 33.1211L16.4728 32.2135C6.42951 36.8589 0.000133901 46.9158 0 57.9814L1 57.9814ZM16.8926 33.1211L17.3124 34.0287C32.019 27.2264 47.4567 22.64 63.1494 20.2681L63 19.2793L62.8506 18.2905C46.9727 20.6904 31.3527 25.331 16.4728 32.2135L16.8926 33.1211ZM63 19.2793H64V15H63H62V19.2793H63ZM63 15H64C64 12.7909 65.7909 11 68 11L68 10L68 9C64.6863 9 62 11.6863 62 15H63ZM68 10V11H109V10V9H68V10Z",
    fill: "#D3EAFB",
    mask: "url(#path-1-outside-1_200_390)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_200_390",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 17,
    width: 175,
    height: 199
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 57.9818C1 47.3058 7.20284 37.6026 16.8925 33.1208V33.1208C62.3189 12.1096 114.681 12.1096 160.107 33.1208V33.1208C169.797 37.6026 176 47.3058 176 57.9818V202C176 209.732 169.732 216 162 216H15C7.26801 216 1 209.732 1 202V57.9818Z",
    fill: "url(#paint0_linear_200_390)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_200_390)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 102.5C-1.83719 107.147 -28.5 155.5 -28.5 155.5L-17 217.5H205L201 115C201 115 181.722 96.0957 167 98C151.654 99.985 149.665 104.063 135 109C112.147 116.693 103.435 95.0538 80.5 102.5C71.7397 105.344 66.8321 106.387 58 109C40.5104 114.174 33.1171 97.7777 15.5 102.5Z",
    fill: "url(#paint1_linear_200_390)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 110.5C8.16281 115.147 -18.5 163.5 -18.5 163.5L-7 225.5H215L211 123C211 123 191.722 104.096 177 106C161.654 107.985 159.665 112.063 145 117C122.147 124.693 113.435 103.054 90.5 110.5C81.7397 113.344 76.8321 114.387 68 117C50.5104 122.174 43.1171 105.778 25.5 110.5Z",
    fill: "url(#paint2_linear_200_390)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 119.5C-11.8372 124.147 -38.5 172.5 -38.5 172.5L-27 234.5H195L191 132C191 132 171.722 113.096 157 115C141.654 116.985 139.665 121.063 125 126C102.147 133.693 93.4346 112.054 70.5 119.5C61.7397 122.344 56.8321 123.387 48 126C30.5104 131.174 23.1171 114.778 5.5 119.5Z",
    fill: "url(#paint3_linear_200_390)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 25,
    y: 55,
    width: 127,
    height: 127
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1px)",
      clipPath: "url(#bgblur_0_200_390_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 57,
    width: 123,
    height: 123,
    rx: 61.5,
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 57.5,
    width: 122,
    height: 122,
    rx: 61,
    stroke: "white",
    strokeOpacity: 0.56
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_200_390_clip_path",
    transform: "translate(-25 -55)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 57,
    width: 123,
    height: 123,
    rx: 61.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_200_390",
    x1: 83,
    y1: -69,
    x2: 82,
    y2: 269.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76B7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_200_390",
    x1: 88.25,
    y1: 97.8652,
    x2: 88.25,
    y2: 217.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AED5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_200_390",
    x1: 98.25,
    y1: 105.865,
    x2: 98.25,
    y2: 225.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AED5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_200_390",
    x1: 78.25,
    y1: 114.865,
    x2: 78.25,
    y2: 234.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AED5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTankIcon);
export default __webpack_public_path__ + "static/media/Tank Icon.9dea7ef827e2f6b4d59a49daa2fcfcc8.svg";
export { ForwardRef as ReactComponent };